import { useEffect, useRef } from 'react';
import { debounce } from '../../utils/util';

interface IUseMouseControl {
  inFunc: () => void;
  outFunc: () => void;
}
export default function(props: IUseMouseControl) {
  const { inFunc, outFunc } = props;
  useEffect(() => {
    window.addEventListener('mousemove', mouseMove);
    return () => window.removeEventListener('mousemove', mouseMove);
  }, []);
  const H = 30; // H应该保证在操作按钮的下方，否则在操作按钮上会导致异常
  const W = 40; // W应该尽量保证在播放按钮的左边部分，这样点击播放后还在范围外

  const isIn = useRef(false); // 鼠标是否在里边，默认不在（虽然正常情况下应该在才对），但不想一来就触发了
  const mouseMove = function(e: MouseEvent) {
    const { screenX, screenY, x, y, clientX, clientY } = e;
    // 注意，全屏时一般会修改掉clientHeight的高度，所以不要吧这个数据放在外面
    const { clientHeight, clientWidth } = document.documentElement;
    // 注意，双屏时，screenX可能是负的，因为屏幕是第一个屏幕左上角为0,0，所以左侧的屏幕就是-1080,0一类的数值
    if (
      clientX < W ||
      clientX > clientWidth - W ||
      clientY < H || clientY > clientHeight - H
    ) {
      if (isIn.current) {
        console.log('out');
        outFunc();
        isIn.current = false;
      }
    } else {
      //

      if (!isIn.current) {
        // console.log('in');
        inFunc();
        isIn.current = true;
      }
    }
  };
}
